export const Types = {
    LOGIN: 'LOGIN',
    TRIP_LOGIN: 'TRIP_LOGIN',
    LOGOUT: 'LOGOUT'
  }